export default "__VITE_ASSET__DSGYxlXd__"